import { WizardButtons } from '../../Wizard/WizardButtons';

export const DeliveryMethod = (props) => {
  const docuSignHandler = () => {
    props.setClickOnDocu(true);
    props.nextHandler();
  };

  const clickOnSentViaEmailHandling = () => {
    props.setClickOnDocu(false);
    props.nextHandler();
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div>
        <WizardButtons {...props} nextHandler={docuSignHandler} nextText="Send Via DocuSign" />
      </div>
      <div>
        <WizardButtons
          {...props}
          nextHandler={clickOnSentViaEmailHandling}
          nextText="Send Via mail"
        />
      </div>
    </div>
  );
};
